import { buildModelManager } from "../builder.js";
const DefaultSegmentPhoneNumberBatchSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  phoneNumbers: true,
  segmentId: true,
  updatedAt: true
};
const modelApiIdentifier = "segmentPhoneNumberBatch";
const pluralModelApiIdentifier = "segmentPhoneNumberBatches";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSegmentPhoneNumberBatch",
    operationReturnType: "CreateSegmentPhoneNumberBatch",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      segmentPhoneNumberBatch: { required: false, type: "CreateSegmentPhoneNumberBatchInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSegmentPhoneNumberBatches",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateSegmentPhoneNumberBatchesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection
  },
  {
    type: "action",
    operationName: "updateSegmentPhoneNumberBatch",
    operationReturnType: "UpdateSegmentPhoneNumberBatch",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      segmentPhoneNumberBatch: { required: false, type: "UpdateSegmentPhoneNumberBatchInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateSegmentPhoneNumberBatches",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateSegmentPhoneNumberBatchesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection
  },
  {
    type: "action",
    operationName: "deleteSegmentPhoneNumberBatch",
    operationReturnType: "DeleteSegmentPhoneNumberBatch",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSegmentPhoneNumberBatches",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSegmentPhoneNumberBatch",
    operationReturnType: "UpsertSegmentPhoneNumberBatch",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      segmentPhoneNumberBatch: { required: false, type: "UpsertSegmentPhoneNumberBatchInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSegmentPhoneNumberBatchResult": { hasReturnType: false },
      "... on UpdateSegmentPhoneNumberBatchResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertSegmentPhoneNumberBatches",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertSegmentPhoneNumberBatchesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSegmentPhoneNumberBatchSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "segmentPhoneNumberBatchGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SegmentPhoneNumberBatchManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSegmentPhoneNumberBatchSelection,
  operations
);
export {
  DefaultSegmentPhoneNumberBatchSelection,
  SegmentPhoneNumberBatchManager
};
//# sourceMappingURL=SegmentPhoneNumberBatch.js.map
